/* 規約とポリシー — サイドナビによるSPA的切替 + ディープリンク（#terms 等）
   JS無効時は全ポリシーが縦積み表示される（CSSの .legal--js 付与でのみ切替モード）。*/
(function () {
  function init(root) {
    if (!root || root.dataset.legalInit === '1') return;
    root.dataset.legalInit = '1';

    var items = root.querySelectorAll('[data-legal-target]');
    var docs = root.querySelectorAll('[data-legal-doc]');
    if (!items.length || !docs.length) return;

    /* 有効なタブは実際に置かれている文書から作る(2026-08-25)。
       設定で文書を非表示にしたとき、そのハッシュで開いても
       本文が空にならないようにするため。 */
    var VALID = [];
    for (var d = 0; d < docs.length; d += 1) {
      VALID.push(docs[d].getAttribute('data-legal-doc'));
    }
    var DEFAULT_ID = VALID[0];

    function show(id, updateHash) {
      var i;
      for (i = 0; i < docs.length; i++) {
        docs[i].classList.toggle('is-active', docs[i].getAttribute('data-legal-doc') === id);
      }
      for (i = 0; i < items.length; i++) {
        items[i].classList.toggle('is-active', items[i].getAttribute('data-legal-target') === id);
      }
      if (updateHash) {
        try { history.replaceState(null, '', '#' + id); } catch (e) {}
      }
    }

    // 切替モードを有効化（これで非アクティブが非表示になる）
    root.classList.add('legal--js');

    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function (e) {
        e.preventDefault();
        var id = this.getAttribute('data-legal-target');
        if (VALID.indexOf(id) === -1) return;
        show(id, true);
        try { window.scrollTo(0, 0); } catch (err) {}
      });
    }

    // ディープリンク: マウント時にハッシュが有効値なら初期表示を上書き
    var hash = '';
    try { hash = (location.hash || '').replace('#', ''); } catch (e) {}
    show(VALID.indexOf(hash) !== -1 ? hash : DEFAULT_ID, false);

    // ハッシュ変更（フッターリンク等の遷移）に追随
    window.addEventListener('hashchange', function () {
      var h = '';
      try { h = (location.hash || '').replace('#', ''); } catch (e) {}
      if (VALID.indexOf(h) !== -1) {
        show(h, false);
        try { window.scrollTo(0, 0); } catch (err) {}
      }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-legal-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // テーマエディタでのセクション再読込に対応
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-legal-root]');
    if (root) init(root);
  });
})();
